/** Separate settlement columns; the payment's status remains unchanged. */
export function settlementExportFields(transaction: {
    merchant_settle?: boolean;
    merchant_settlement_id?: string | null;
}) {
    return {
        merchant_settle: transaction.merchant_settle === true,
        merchant_settlement_id: transaction.merchant_settle ? transaction.merchant_settlement_id || '' : '',
    };
}

/** Provider participation is independent of the merchant settlement. */
export function providerSettlementExportFields(transaction: {
    provider_settle?: boolean;
    provider_settlement_id?: string | null;
}) {
    return {
        provider_settle: transaction.provider_settle === true,
        provider_settlement_id: transaction.provider_settle ? transaction.provider_settlement_id || '' : '',
    };
}
